module.exports = __webpack_public_path__ + "img/expand-sidebar.f65166dd.svg";